/* eslint-disable no-param-reassign */
// goalsSlice.js
import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    nps: true,
    userData: JSON.parse(localStorage.getItem('userData')) || undefined,
  },
  reducers: {
    updateNpsState: (state, action) => {
      if (action.payload) {
        state.nps = action.payload.nps;
      }
    },
    updateUserData: (state, action) => {
      if (action.payload) {
        state.userData = action.payload;
        localStorage.setItem('userData', JSON.stringify(action.payload));
      }
    },
  },
});

// your exported actions and reducer...
export const { updateNpsState, updateUserData } = userSlice.actions;
export default userSlice.reducer;
